import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateDeliveryZoneStatus } from "./updateDeliveryZoneStatus.request";

const useUpdateDeliveryZoneStatus = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateDeliveryZoneStatus,
    onError: toastServerError,
    ...options
  });
};

export default useUpdateDeliveryZoneStatus;
